module.exports = __webpack_public_path__ + "img/Contour.b52613b4.png";